module.exports = __webpack_public_path__ + "img/SES_151250001.4778a42e.jpg";